<template>
    <div>
        <h2>{{$t("wp.wpServices")}}</h2>
        <span> {{$t("wp.wpServicesIntegrationCompleted")}} </span>
        <div class="mt-5">
            <img v-if="!!imageData" :src="imageData" alt="QR Code" class="qr-code" :key="imageRefreshKey" />
        </div>
    </div>
</template>

<script>
import CONFIG from "../../config/config";
import { getPersistenceData } from "../../utils/persistenceStorage";
import { mapMutations, mapState } from "vuex";
import { getWhatsappSS } from "../../api/whatsapp";

export default {
    name: "WPStatusViewer",
    data() {
        return {
            imageRefreshKey: 0,
            imageData: null,
        };
    },
    computed: {
        ...mapState({
            settings: (state) => state.setting.settings,
            isSettingInitialized: (state) => state.setting.initialized,
            site: (state) => state.site.site,
            initialized: (state) => state.whatsapp.info.initialized,
            status: (state) => state.whatsapp.info.status,
            siteId: (state) => state.site.site._id,
        }),
    },
    methods: {
        getSnapshotAddress() {
            return `${CONFIG.WHATSAPP.snapshotAddress}?siteId=${this.siteId}&token=${getPersistenceData(
                "Admin-Token"
            )}&r=${Math.random() * 1000}`;
        },
        fetchSS() {
            getWhatsappSS()
                .then((res) => {
                    console.log("imageData", res);
                    if (_.get(res, "data.response")) {
                        const image = _.get(res, "data.response");
                        console.log("image", image);
                        this.imageData = image;
                        this.imageRefreshKey++;
                    } else {
                        this.imageData = null;
                    }
                })
                .catch((err) => {
                    console.error(err);
                });
        },
    },
    mounted() {
        this.fetchSS();
        this.timerId = setInterval(this.fetchSS, 10000);
    },
    beforeDestroy() {
        this.clearInterval(this.timerId);
    },
};
</script>

<style scoped></style>
